import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import wtyReportApi from "../../services/warrantyReportAxios";

const initialState = {
    relatedAccounts: [], isHighRiskDealer: false, loading: false, error: null
}

export const getRelatedAccounts = createAsyncThunk('dealers/getRelatedAccounts', async ({userId}) => {

    const params = {
        xId: userId
    }

    const dealerRelatedAccountsUrl = "/dealer/getRelatedAccounts";

    try {
        const response = await wtyReportApi.get(dealerRelatedAccountsUrl, params);
        if (response.status !== 200) {
            throw new Error("Calling dealer list api to fetch related accounts failed");
        }
        return await response.data;
    } catch (error) {
        throw error;
    }
});

const dealerRelatedAccountsSlice = createSlice({
    name: "relatedAccounts", initialState, reducers: {
        setRelatedAccounts: (state, action) => {
            state.relatedAccounts = action.payload;
        }
    }, extraReducers(builder) {
        builder
            .addCase(getRelatedAccounts.pending, (state) => {
                state.loading = true;
                state.relatedAccounts = [];
            })
            .addCase(getRelatedAccounts.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(getRelatedAccounts.fulfilled, (state, action) => {
                state.loading = false;
                state.relatedAccounts = action.payload.relatedAccountsList;
                state.isHighRiskDealer = action.payload?.dealerRestricted;
            })
    }
})


export const {setRelatedAccounts} = dealerRelatedAccountsSlice.actions;

export const relatedAccounts = (state) => state.dealerResponse.relatedAccounts;

export const isHighRiskDealer = (state) => state.dealerResponse.isHighRiskDealer;

export const relatedAccountsSearchLoading = (state) => state.dealerResponse.loading;

export const relatedAccountsError = (state) => state.dealerResponse.error;


export default dealerRelatedAccountsSlice.reducer;